import type { CustomIconProps } from '../types';

const Minus = ({ width, height }: CustomIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '2'}
        viewBox="0 0 12 2"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M-4.10625e-08 1C-1.83843e-08 0.723858 0.223858 0.5 0.5 0.5L11.5 0.500001C11.7761 0.500001 12 0.723859 12 1C12 1.27614 11.7761 1.5 11.5 1.5L0.5 1.5C0.223858 1.5 -6.37407e-08 1.27614 -4.10625e-08 1Z"
            fill="#414042"
        />
    </svg>
);

export default Minus;
